import React from 'react';
import { trackLinkClick } from 'helpers/eventTracking';
import { StyledRichText } from './styles';
import { RichTextData } from '../types';

const AccordionRichTextBlock: React.FC<RichTextData> = ({ rich_text }) => (
  <StyledRichText
    html={rich_text.html}
    data-cy="Accordion Rich Text"
    onLinkClick={trackLinkClick}
    focusable
  />
);

export default React.memo(AccordionRichTextBlock);
